module.exports = __webpack_public_path__ + "img/empty.c5480f09.svg";